import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=105fa3be&"
import script from "./BaseLabel.vue?vue&type=script&lang=ts&"
export * from "./BaseLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports